import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { compose, pure, lifecycle, withHandlers, withState } from 'recompose';
import { getGroups, getUsersByGroupId } from '../../../utils/apiGroup';

import AuxDiv from '../../core/AuxDiv';
import { ModalBody, ModalButton } from '../../core/ModalGroup';
import Buttons from '../../core/Buttons';
import Icon from '../../core/Icon';
import SearchInput from '../../core/SearchInput';

import {
  StyledSearchInput,
  GroupSelectionBody,
  GroupSelectionBodyDepartment,
  GroupSelectionBodyDepartmentCell,
  GroupSelectionData,
  GroupSelectionHead,
  GroupSelectionHeadDepartment,
  GroupSelectionHeritage,
  GroupSelectionTxt,
  GroupSelectionTxtLeft,
  GroupSelectionWrap,
  DataUsers,
  IconUsers,
  TooltipContent,
  StyledTooltip,
  TooltipUser,
  StyledRadioBody
} from './style';

import { View } from '../../../../assets/images';

const ModalTabMultipleGroups = ({
  title,
  onGetGroupsByName,
  groupList,
  showDetailsUser,
  getUsersNamebyGroup,
  onChange,
  groupSelected,
  onSaveGroup,
  send,
  paginate,
  folderPermissionType
}) => (
  <AuxDiv>
    <ModalBody>
      <StyledSearchInput>
        <SearchInput onChangeSearch={onGetGroupsByName} name="search-groups" />
      </StyledSearchInput>

      {/* header */}
      <GroupSelectionWrap size={450} onScroll={paginate}>
        <GroupSelectionHead>
          <GroupSelectionHeadDepartment size={300}>
            <GroupSelectionTxtLeft>{title}</GroupSelectionTxtLeft>
          </GroupSelectionHeadDepartment>
          <GroupSelectionHeadDepartment size={110}>
            <GroupSelectionTxtLeft>Usuarios</GroupSelectionTxtLeft>
          </GroupSelectionHeadDepartment>
          <GroupSelectionHeadDepartment size={210}>
            <GroupSelectionTxtLeft>Descripción</GroupSelectionTxtLeft>
          </GroupSelectionHeadDepartment>
          <GroupSelectionHeadDepartment size={110}>
            <GroupSelectionTxt>Seleccionar</GroupSelectionTxt>
          </GroupSelectionHeadDepartment>
        </GroupSelectionHead>
        {/* header - END */}
        {/* body */}
        {groupList.map(group => (
          <GroupSelectionBody key={group.id}>
            <GroupSelectionBodyDepartment size={300}>
              <GroupSelectionHeritage>
                <GroupSelectionData>{group.name}</GroupSelectionData>
              </GroupSelectionHeritage>
            </GroupSelectionBodyDepartment>
            <GroupSelectionBodyDepartmentCell size={110}>
              <GroupSelectionHeritage>
                <DataUsers>({group.users})</DataUsers>
                <IconUsers>
                  <TooltipContent
                    onMouseEnter={() => showDetailsUser(group.id)}
                  >
                    <Icon hover expanded size="s" color="main" svg={View} />
                    {group.usersGroup && group.usersGroup.length ? (
                      <StyledTooltip position="bottom">
                        <TooltipUser>Usuarios:</TooltipUser>
                        {getUsersNamebyGroup(group.usersGroup)}
                      </StyledTooltip>
                    ) : (
                      false
                    )}
                  </TooltipContent>
                </IconUsers>
              </GroupSelectionHeritage>
            </GroupSelectionBodyDepartmentCell>
            <GroupSelectionBodyDepartment size={210}>
              <GroupSelectionHeritage>
                <GroupSelectionData>{group.description}</GroupSelectionData>
              </GroupSelectionHeritage>
            </GroupSelectionBodyDepartment>
            <GroupSelectionBodyDepartment size={110}>
              <StyledRadioBody
                checked={
                  groupSelected !== undefined
                    ? group.id === groupSelected
                    : false
                }
                id={group.id.toString()}
                name={group.text}
                onChange={() => onChange(group.id)}
              />
            </GroupSelectionBodyDepartment>
          </GroupSelectionBody>
        ))}
        {/* body - END */}
      </GroupSelectionWrap>
    </ModalBody>
    <ModalButton>
      <Buttons
        secondary
        className="fr"
        type="submit"
        small
        onClick={() => onSaveGroup(groupSelected, folderPermissionType)}
        disabled={groupSelected === undefined}
      >
        {send === 'GROUP' ? 'Guardar' : 'Continuar'}
      </Buttons>
    </ModalButton>
  </AuxDiv>
);

ModalTabMultipleGroups.propTypes = {
  title: PropTypes.string,
  groupList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
      users: PropTypes.number
    })
  ),
  onChange: PropTypes.func,
  onGetGroupsByName: PropTypes.func,
  onSaveGroup: PropTypes.func,
  groupSelected: PropTypes.number,
  showDetailsUser: PropTypes.func,
  getUsersNamebyGroup: PropTypes.func,
  paginate: PropTypes.func,
  send: PropTypes.string
};
export default compose(
  pure,
  withState('groupList', 'setGroupList', []),
  withState('pageGroup', 'setPageGroup', 0),
  withState('totalPage', 'setTotalPage', 0),
  withState('totalPageUser', 'setTotalPageUser', 0),
  withState('loadingGroup', 'setLoadingGroup', false),
  withState('nameGroup', 'setNameGroup', ''),
  withState('selectedTab', 'setSelectedTab', 0),
  withState('groupSelected', 'setGroupSelected', ({ rolEdit }) =>
    rolEdit ? rolEdit.groupId : null
  ),
  withHandlers({
    onGetGroups: ({
      setGroupList,
      groupList,
      setTotalPage,
      setPageGroup,
      setLoadingGroup,
      groupSelected
    }) => (name = '', page = 0) => {
      getGroups({ name, page }).then(res => {
        const newGroupList = res.content.map(group => ({
          ...group,
          included: groupSelected === group.id
        }));
        if (page > 0 && res.content) {
          setGroupList(groupList.concat(newGroupList));
          setLoadingGroup(false);
        } else {
          setGroupList(newGroupList);
          setTotalPage(Math.floor(res.total / 10));
          setPageGroup(page + 1);
        }
      });
    }
  }),
  withHandlers({
    showDetailsUser: ({ groupList, setGroupList }) => id => {
      getUsersByGroupId(id).then(users => {
        const newGroupList = groupList.map(group =>
          group.id === id ? { ...group, usersGroup: users } : group
        );
        setGroupList(newGroupList);
      });
    },
    getUsersNamebyGroup: () => groupUsers =>
      groupUsers
        .filter((group, i) => i <= 9)
        .map(group => group.name)
        .join(', ')
        .toUpperCase(),
    onChange: ({ setGroupSelected }) => groupId => {
      setGroupSelected(groupId);
    },
    onGetGroupsByName: ({
      onGetGroups,
      setPageGroup,
      setNameGroup
    }) => name => {
      setNameGroup(name);
      onGetGroups(name);
      setPageGroup(0);
    },
    onGetUsersByName: ({ onGetGroups, setPageGroup, setNameGroup }) => name => {
      if (name.length > 2) {
        setNameGroup(name);
        onGetGroups(name);
      } else {
        setTimeout(() => {
          setNameGroup('');
          onGetGroups();
        }, 500);
      }
      setPageGroup(0);
    },
    paginate: ({
      onGetGroups,
      pageGroup,
      setPageGroup,
      loadingGroup,
      setLoadingGroup,
      name
    }) => event => {
      const node = findDOMNode(event.currentTarget);
      if (
        node.scrollHeight - (event.currentTarget.scrollTop + 450) <= 0 &&
        !loadingGroup
      ) {
        setLoadingGroup(true);
        onGetGroups(name, pageGroup);
        setPageGroup(pageGroup + 1);
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.onGetGroups();
    }
  })
)(ModalTabMultipleGroups);
